import React from 'react';

import {Icon, Affirm as AffirmIcon} from '@optimaxdev/icons';

import classNames from 'classnames';

import {useFeature} from 'components/feature';

import s from './checkoutIcons.scss';

/**
 * Amazon pay icon
 * @returns {Node} - Amazon pay icon
 */
export const AmazonPayIcon = () => (
    <div className={s.iconWrapper}>
        <div className={s.amazonPay} />
        <div className={s.affirmWrapper}>
            <div className={s.divider} />
            <Icon height={37} icon={AffirmIcon} />
        </div>
    </div>
);

/**
 * PayPal icon
 * @returns {Node} - PayPal icon
 */
export const PayPalIcon = () => {
    const isFacelift = useFeature('dCheckoutFacelift');
    return <div className={classNames(s.payPal, {[s.payPalFacelift]: isFacelift})} />;
};
